import React, { useState } from 'react';
import { Redirect } from "react-router-dom";
import { userService } from '../../_services';
import { useMultiplePopups } from '../../hooks/usePopup';
import PagesWrapper from '@/components/ui/shared/PagesWrapper';
import { Card, CardContent } from '@/components/ui/card';
import { BetaBadge } from '@/components/ui/BetaBadge';
import { User, Users, KeyRound, ShieldCheck } from 'lucide-react';
import PasskeyRegistration from '../PasskeyRegistration';

import InfoPopup from './Info';
import ReferralPopup from './Referral';
import RepPopup from './RepPopup';
import ResetPasswordPopup from '../ChangePassword';

function Tools({ AnalyticData }) {
    const [userdata] = useState(() => {
        try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
    });

    const { popups, togglePopup, closePopup } = useMultiplePopups(['info', 'referral', 'reps', 'resetPassword', 'passkey']);

    const userType = userService.Get_User_Type();
    if (userService.Check_LoggedIn_Status() === 'Login') return <Redirect to="/login" />;
    if (['admin', 'wholesaler'].includes(userType?.toLowerCase())) return <Redirect to='/pageNotFound' />;

    const toolItems = [
        { id: 'info', title: 'My Info', description: 'View and manage your information', icon: User, onClick: () => togglePopup('info') },
        { id: 'reps', title: 'Reps', description: 'View active and inactive reps', icon: Users, onClick: () => togglePopup('reps') },
        { id: 'resetPassword', title: 'Reset Password', description: 'Change your account password', icon: KeyRound, onClick: () => togglePopup('resetPassword') },
        { id: 'passkey', title: 'Manage Passkeys', description: 'Register a passkey for passwordless login', icon: ShieldCheck, onClick: () => togglePopup('passkey') }
    ];

    return (
        <PagesWrapper>
            <div className="space-y-6">
                <div className="flex items-center">
                    <h1 className="text-2xl font-semibold text-foreground">
                        Tools
                        <BetaBadge />
                    </h1>
                </div>

                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {toolItems.map((item) => {
                        const Icon = item.icon;
                        return (
                            <Card key={item.id} className="cursor-pointer hover:shadow-md transition-all hover:border-primary/50 group" onClick={item.onClick}>
                                <CardContent className="p-4">
                                    <div className="flex items-start gap-4">
                                        <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0 group-hover:bg-primary/20 transition-colors">
                                            <Icon className="h-6 w-6 text-primary" />
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <p className="font-medium text-foreground">{item.title}</p>
                                            <p className="text-sm text-muted-foreground mt-1">{item.description}</p>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        );
                    })}
                </div>
            </div>

            {popups.info && <InfoPopup text='Rep Popup' calldata="callonce" closePopup={() => closePopup('info')} />}
            {popups.referral && <ReferralPopup whName={userdata?.wholesaler} text='Rep Popup' calldata="callonce" closePopup={() => closePopup('referral')} />}
            {popups.reps && <RepPopup text='Active & Inactive Reps' calldata="callonce" closePopup={() => closePopup('reps')} />}
            {popups.resetPassword && <ResetPasswordPopup text='Reset Password' calldata="callonce" closeResetPasswordPopup={() => closePopup('resetPassword')} />}
            {popups.passkey && <PasskeyRegistration userId={userdata?.id} username={userdata?.email || userdata?.username} onClose={() => closePopup('passkey')} />}
        </PagesWrapper>
    );
}

export default Tools;
